import VueI18n from 'vue-i18n';
import { GroupMember, PartialUser } from '@front-app/services/UserApi/UserModel';
import { getGroupMemberName, getUsername } from '@front-app/util/user';
import { SetupContext } from '@vue/composition-api';

export type StringTranslator = typeof VueI18n.prototype.t;

export const useTranslate = (ctx: SetupContext): StringTranslator => ctx.root.$t.bind(ctx.root);

export const useUsername = (ctx: SetupContext): (user: PartialUser) => string => {
	const t = useTranslate(ctx);
	return (user: PartialUser) => getUsername(t, user);
};

export const useGroupMemberName = (ctx: SetupContext): (user: GroupMember) => string => {
	const t = useTranslate(ctx);
	return (user: GroupMember) => getGroupMemberName(t, user);
};
